import {Viewable} from '../protocols/viewable';
import {Subscribable} from './subscribable';

export abstract class BaseComponent extends Subscribable implements Viewable {
  abstract setupBindings();
  abstract setupViews();
}
